import type { Component, JSX } from 'solid-js'
import { Show } from 'solid-js'

export interface ChartContainerProps {
  hasData: boolean
  fallbackMessage?: string
  fallback?: JSX.Element
  class?: string
  children: JSX.Element
}

const ChartContainer: Component<ChartContainerProps> = (props) => {
  const defaultFallback = () => (
    <div class="py-12 text-center text-gray-500">{props.fallbackMessage || 'No data available'}</div>
  )

  return (
    <Show when={props.hasData} fallback={props.fallback || defaultFallback()}>
      <div class={`rounded-lg border border-gray-200 bg-white p-6 shadow-sm ${props.class || ''}`}>
        {props.children}
      </div>
    </Show>
  )
}

export default ChartContainer

export interface ChartContainerWithHeaderProps extends ChartContainerProps {
  title?: string
  titleKey?: string
  headerRight?: JSX.Element
}

export const ChartContainerWithHeader: Component<ChartContainerWithHeaderProps> = (props) => {
  return (
    <ChartContainer hasData={props.hasData} fallback={props.fallback} fallbackMessage={props.fallbackMessage}>
      <Show when={props.title || props.headerRight}>
        <div class="mb-4 flex items-center justify-between">
          <Show when={props.title}>
            <h3 class="text-lg font-bold text-gray-900">{props.title}</h3>
          </Show>
          {props.headerRight}
        </div>
      </Show>
      {props.children}
    </ChartContainer>
  )
}
